// Reusable labeled form field wrapper for the broker registration form.
import React from "react";
import "./BrokerRegistration.css";

const BrokerFormField = ({ icon, label, error, children, required = false }) => {
    return (
        <div className={`broker-field${error ? " broker-field--error" : ""}`}>
            <div className="broker-field__inner">
                <div className="broker-field__label-row">
                    {icon && <span className="broker-field__icon">{icon}</span>}
                    <label className="broker-field__label">
                        {label}
                        {required && <span className="broker-field__required">*</span>}
                    </label>
                </div>
                <div className="broker-field__control">{children}</div>
            </div>
            {error && (
                <p className="broker-field__error">
                    <span className="broker-field__error-icon">⚠</span> {error}
                </p>
            )}
        </div>
    );
};

export default BrokerFormField;
